export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [15,[2]],
		"/(app)/admin": [16,[2,3]],
		"/(app)/admin/evaluations": [17,[2,3]],
		"/(app)/admin/functions": [18,[2,3]],
		"/(app)/admin/functions/create": [19,[2,3]],
		"/(app)/admin/functions/edit": [20,[2,3]],
		"/(app)/admin/settings": [21,[2,3]],
		"/(app)/admin/users": [22,[2,3]],
		"/auth": [68],
		"/(app)/channels/[id]": [24,[2]],
		"/(app)/cps-ready": [25,[2]],
		"/(app)/cps-ready/[caseId]": [26,[2]],
		"/(app)/c/[id]": [23,[2]],
		"/error": [69],
		"/(app)/home": [27,[2,4]],
		"/(app)/investigator": [28,[2]],
		"/(app)/logbook": [29,[2]],
		"/(app)/module-unavailable": [30,[2]],
		"/(app)/notes": [31,[2,5]],
		"/(app)/notes/[id]": [32,[2,5]],
		"/(app)/playground": [33,[2,6]],
		"/(app)/playground/completions": [34,[2,6]],
		"/(app)/running-log": [35,[2]],
		"/(app)/start": [36,[2]],
		"/s/[id]": [70],
		"/(app)/tools": [37,[2]],
		"/(app)/tools/geoclip": [38,[2]],
		"/(app)/tools/miami-mode": [39,[2,7]],
		"/(app)/tools/osint": [40,[2,8]],
		"/(app)/tools/osint/crypto": [41,[2,8]],
		"/(app)/tools/osint/discover": [42,[2,8]],
		"/(app)/tools/osint/graph": [43,[2,8]],
		"/(app)/tools/osint/intel-map": [44,[2,8]],
		"/(app)/tools/osint/tool": [45,[2,8,9]],
		"/(app)/tools/osint/watchlist": [46,[2,8]],
		"/(app)/tools/virtual-devices": [47,[2,10]],
		"/(app)/tools/voice-memos": [48,[2,11]],
		"/(app)/triage": [49,[2,12]],
		"/(app)/warrants": [50,[2]],
		"/(app)/warrants/renew": [52,[2]],
		"/(app)/warrants/[id]/renewals": [51,[2,13]],
		"/(app)/watchlist": [53,[2]],
		"/watch": [71],
		"/(app)/workspace": [54,[2,14]],
		"/(app)/workspace/functions/create": [55,[2,14]],
		"/(app)/workspace/knowledge": [56,[2,14]],
		"/(app)/workspace/knowledge/create": [58,[2,14]],
		"/(app)/workspace/knowledge/[id]": [57,[2,14]],
		"/(app)/workspace/models": [59,[2,14]],
		"/(app)/workspace/models/create": [60,[2,14]],
		"/(app)/workspace/models/edit": [61,[2,14]],
		"/(app)/workspace/prompts": [62,[2,14]],
		"/(app)/workspace/prompts/create": [63,[2,14]],
		"/(app)/workspace/prompts/edit": [64,[2,14]],
		"/(app)/workspace/tools": [65,[2,14]],
		"/(app)/workspace/tools/create": [66,[2,14]],
		"/(app)/workspace/tools/edit": [67,[2,14]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';